import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_pen-nocolor",
  "use": "svg_pen-nocolor-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_pen-nocolor\"><path d=\"M11.333 2.19A1.886 1.886 0 0 1 14 4.857l-9 9-3.667 1 1-3.667 9-9Z\" stroke=\"currentColor\" stroke-width=\"1.354\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol